var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/* eslint-disable camelcase */
/* eslint-disable @typescript-eslint/naming-convention */
import api from '@utils/axios';
function isNotFound(error) {
    var _a;
    const e = error;
    return typeof error === 'object' && error !== null && ((_a = e.response) === null || _a === void 0 ? void 0 : _a.status) === 404;
}
function mapInspectionAssessment(response) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    return {
        id: response.id,
        rating: response.rating,
        score: response.score,
        summary: response.summary,
        descriptionMd: (_b = (_a = response.descriptionMd) !== null && _a !== void 0 ? _a : response.description_md) !== null && _b !== void 0 ? _b : null,
        ipaTraceId: (_d = (_c = response.ipaTraceId) !== null && _c !== void 0 ? _c : response.ipa_trace_id) !== null && _d !== void 0 ? _d : null,
        status: response.status,
        completedAt: (_f = (_e = response.completedAt) !== null && _e !== void 0 ? _e : response.completed_at) !== null && _f !== void 0 ? _f : null,
        generatedAt: (_h = (_g = response.generatedAt) !== null && _g !== void 0 ? _g : response.generated_at) !== null && _h !== void 0 ? _h : null
    };
}
function mapTechnicianAssessment(response) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    return {
        id: response.id,
        inspectionId: (_b = (_a = response.inspectionId) !== null && _a !== void 0 ? _a : response.inspection_id) !== null && _b !== void 0 ? _b : 0,
        technicianId: (_d = (_c = response.technicianId) !== null && _c !== void 0 ? _c : response.technician_id) !== null && _d !== void 0 ? _d : 0,
        technicianName: (_f = (_e = response.technicianName) !== null && _e !== void 0 ? _e : response.technician_name) !== null && _f !== void 0 ? _f : '',
        rating: response.rating,
        score: response.score,
        summary: response.summary,
        descriptionMd: (_h = (_g = response.descriptionMd) !== null && _g !== void 0 ? _g : response.description_md) !== null && _h !== void 0 ? _h : null,
        status: response.status,
        completedAt: (_k = (_j = response.completedAt) !== null && _j !== void 0 ? _j : response.completed_at) !== null && _k !== void 0 ? _k : null,
        generatedAt: (_m = (_l = response.generatedAt) !== null && _l !== void 0 ? _l : response.generated_at) !== null && _m !== void 0 ? _m : null
    };
}
export function getIpaInspectionAssessment(inspectionId) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const response = yield api.get('/api/internal/ia/inspection_assessment', {
                params: { inspection_id: inspectionId }
            });
            return mapInspectionAssessment(response.data);
        }
        catch (error) {
            if (isNotFound(error))
                return null;
            throw error;
        }
    });
}
export function getIpaTechAssessments(inspectionId) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const response = yield api.get('/api/internal/ia/technician_assessments', { params: { inspection_id: inspectionId } });
            const data = Array.isArray(response.data) ? response.data : response.data.data;
            return data.map(mapTechnicianAssessment);
        }
        catch (error) {
            if (isNotFound(error))
                return [];
            throw error;
        }
    });
}
export function getIpaTechAssessmentDetail(inspectionId, technicianId) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const response = yield api.get('/api/internal/ia/technician_assessments', {
                params: { inspection_id: inspectionId, technician_id: technicianId }
            });
            return mapTechnicianAssessment(response.data);
        }
        catch (error) {
            if (isNotFound(error))
                return null;
            throw error;
        }
    });
}
